import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DashboardTab from './tabs/DashboardTab';
import ExamManagementTab from './tabs/ExamManagementTab';
import AccessPermissionsTab from './tabs/AccessPermissionsTab';
import FiltersSearchTab from './tabs/FiltersSearchTab';
import UserManagementTab from './tabs/UserManagementTab';
import AnalyticsReportsTab from './tabs/AnalyticsReportsTab';
import NotificationsTab from './tabs/NotificationsTab';
import PageContentTab from './tabs/PageContentTab';
import '../../components/tabs/UserManagement.css';
import './ResourcesManagement.css';

const ResourcesManagementPage = () => {
  const { t } = useTranslation('resourcesManagement');
  const [activeInnerTab, setActiveInnerTab] = useState('dashboard');

  const tabs = [
    { id: 'dashboard', label: t('tabs.dashboard'), icon: 'dashboard' },
    { id: 'exam-management', label: t('tabs.examManagement'), icon: 'description' },
    { id: 'access-permissions', label: t('tabs.accessPermissions'), icon: 'lock' },
    { id: 'filters-search', label: t('tabs.filtersSearch'), icon: 'search' },
    { id: 'user-management', label: t('tabs.userManagement'), icon: 'people' },
    { id: 'analytics-reports', label: t('tabs.analyticsReports'), icon: 'bar_chart' },
    { id: 'notifications', label: t('tabs.notifications'), icon: 'notifications' },
    { id: 'page-content', label: t('tabs.pageContent'), icon: 'edit_note' },
  ];

  const renderActiveTab = () => {
    switch (activeInnerTab) {
      case 'dashboard':
        return <DashboardTab />;
      case 'exam-management':
        return <ExamManagementTab />;
      case 'access-permissions':
        return <AccessPermissionsTab />;
      case 'filters-search':
        return <FiltersSearchTab />;
      case 'user-management':
        return <UserManagementTab />;
      case 'analytics-reports':
        return <AnalyticsReportsTab />;
      case 'notifications':
        return <NotificationsTab />;
      case 'page-content':
        return <PageContentTab />;
      default:
        return <DashboardTab />;
    }
  };

  return (
    <div className="section user-management-section resources-management-page">
      <h2>{t('title')}</h2>
      <p className="resources-management-subtitle">{t('subtitle')}</p>

      <div className="user-management-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`tab-button ${activeInnerTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveInnerTab(tab.id)}
          >
            <span className="material-icons">{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      {renderActiveTab()}
    </div>
  );
};

export default ResourcesManagementPage;
